const ENVIRONMENT = process.env.REACT_APP_ENV
  ? process.env.REACT_APP_ENV
  : "develop";

export const BASE_HREF =
  window.document.location.protocol + "//" + window.document.location.host;

export const HOST_NAME = window.document.location.host;
